<template>
  <div style="margin-top:5px;" class="card">
      <b-field>
        <b-input
          :placeholder="$t('insight.chercher_insight')"
          @input="search()"
          type="search"
          icon="magnify"
          v-model="search_query"
        ></b-input>
      </b-field>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  computed: {
    search_query: {
      get: function () {
        return this.$store.state.insight.search_query
      },
      set: function (newValue) {
        this.$store.commit(`UPDATE_SEARCH_QUERY_INPUT`, newValue)
      }
    }
  },
  methods: {
    search () {
      this.$store.commit('SEARCH_INSIGHT', this.search_query)
    }
  }
}
</script>

<style></style>
